quick checkbox

<script>
import * as _ from 'lodash'
export default {
  model: {
    event: 'update',
  },

  props: {
    questionId: { type: Number, required: true },
    questionTitle: { type: String, required: true },
    questionOptions: { type: Array, required: true },
    questionType: { type: String, required: true },
    selected: { type: null, required: true },
  },
  data() {
    return {
      ans: _.cloneDeep(this.selected),
    }
  },

  watch: {
    selected(newValue) {
      if (_.isEmpty(newValue)) {
        this.ans = []
      }
    },

    ans(newValue) {
      if (newValue) {
        this.$emit('update', Object.fromEntries(newValue))
      }
    },
  },
}
</script>

<template>
  <div :class="$style.checkboxWrapp">
    <h3 :class="$style.question">{{ questionTitle }}<sup>*</sup></h3>
    <ul :class="$style.questionOptionList">
      <li v-for="options in questionOptions" :key="options">
        <v-checkbox
          v-model="ans"
          :class="$style.questionCheckbox"
          :label="options"
          :value="ans"
          multiple
        ></v-checkbox>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.question {
  font-size: 18px;
  font-weight: 700;
  line-height: 27px;
}
.question sup {
  color: #f00;
}
.questionOptionList {
  display: flex;
  flex-flow: row wrap;
  padding: 0 !important;
  margin: 0;
  list-style: none;
}
.questionOptionList li {
  flex: 50%;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #000;
}

.questionCheckbox .v-label {
  color: #09101d !important;
}
.questionCheckbox .v-input--selection-controls {
  margin-top: 0 !important;
}
.checkboxWrapp {
  width: 70%;
  overflow: hidden;
}
@media screen and (max-width: 767px) {
  .questionOptionList li {
    flex: 100%;
  }
  .checkboxWrapp {
    width: 100%;
  }
}
</style>

<style scoped>
/deep/ .v-input--selection-controls .v-input__slot > .v-label {
  color: #09101d;
}
</style>
